import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  GET_USER_INFORMATIONS,
  USER_INFORMATIONS_SUCCESS,
  CHANGE_LOGIN_LANGUAGE,
  SEND_EMAIL_RESET_PASSWORD,
  LOGIN_KEYCLOAK,
  UPDATE_ONBOARDING,
  SET_ACCESS_TOKEN,
  SET_INFOS_MULTI_BUSINESS,
  SET_CURRENT_USER,
  SET_FIREWALL_BLOCKED,
  MFA_REQUIRED,
  MFA_CLEAR,
} from "./constants"

export function userLoginUserAction(payload) {
  return {
    type: LOGIN_USER,
    payload,
  }
}

export function userLoginSuccessAction(payload) {
  return {
    type: LOGIN_SUCCESS,
    payload,
  }
}

export function setCurrentUser(payload) {
  return {
    type: SET_CURRENT_USER,
    payload,
  }
}

export function userLogoutAction() {
  return { type: LOGOUT_USER }
}

export function setAccessToken(payload) {
  return {
    type: SET_ACCESS_TOKEN,
    payload,
  }
}

// USER INFORMATIONS
export function userGetInformationsAction() {
  return {
    type: GET_USER_INFORMATIONS,
  }
}

export function userGetInformationsSuccessAction(payload) {
  return {
    type: USER_INFORMATIONS_SUCCESS,
    payload,
  }
}

export function changeLanguageLoginAction(payload) {
  return {
    type: CHANGE_LOGIN_LANGUAGE,
    payload,
  }
}

export const sendEmailResetPasswordAction = payload => ({
  type: SEND_EMAIL_RESET_PASSWORD,
  payload,
})

export const loginKeycloakAction = payload => ({
  type: LOGIN_KEYCLOAK,
  payload,
})

export const updateUserOnBoardingAction = payload => ({
  type: UPDATE_ONBOARDING,
  payload,
})

export const setInfosMultiBusinessAction = payload => ({
  type: SET_INFOS_MULTI_BUSINESS,
  payload,
})

export const setFirewallBlocked = (message) => ({
  type: SET_FIREWALL_BLOCKED,
  payload: message,
})

export const mfaRequiredAction = (payload) => ({
  type: MFA_REQUIRED,
  payload,
})

export const mfaClearAction = () => ({
  type: MFA_CLEAR,
})
